// RESONATE_TRIAL_GUARANTEE_V1
// One-line reassurance beside primary trial CTAs sitewide. Rendered wherever a
// "Start for free" button appears so anxiety about the card / commitment is
// answered on the same visual beat.
import { Check } from "lucide-react";

/**
 * Props:
 *  - variant: "compact" (default, one line beside CTA) | "full" (3-line block for pricing / signup)
 *  - align:   "left" | "center" (default "center")
 *  - tone:    "light" (on light backgrounds, default) | "dark" (on dark card / hero)
 */
export const TrialGuarantee = ({ variant = "compact", align = "center", tone = "light" }) => {
  const alignClass = align === "left" ? "justify-start text-left" : "justify-center text-center";
  const textColor = tone === "dark" ? "text-white/80" : "text-[rgba(44,44,42,0.72)]";
  const teal = "#1D9E75";

  if (variant === "compact") {
    return (
      <div
        data-testid="trial-guarantee-compact"
        className={`flex items-center gap-1.5 text-[12.5px] leading-snug mt-3 ${alignClass} ${textColor}`}
      >
        <span aria-hidden className="inline-flex w-3.5 h-3.5 rounded-full items-center justify-center flex-shrink-0" style={{ background: teal }}>
          <Check className="w-2 h-2 text-white" strokeWidth={3.5} />
        </span>
        <span>30-day money-back guarantee - $0 due today, cancel in two clicks.</span>
      </div>
    );
  }

  // Full 3-line block for pricing cards / signup screens.
  const lines = [
    "$0 due today.",
    "We email you 2 days before your trial ends - cancel in one click, no charge.",
    "Not happy after paying? Full refund within 30 days, no questions asked.",
  ];
  return (
    <div
      data-testid="trial-guarantee-full"
      role="note"
      aria-label="Trial guarantee"
      className={`rounded-xl border ${tone === "dark" ? "border-white/15 bg-white/[0.06]" : "border-[rgba(44,44,42,0.10)] bg-[#F1EFE8]"} px-4 py-3.5`}
    >
      <ul className="space-y-2">
        {lines.map((l, i) => (
          <li key={i} className={`flex items-start gap-2 text-[13px] leading-snug ${tone === "dark" ? "text-white/90" : "text-[#2C2C2A]"}`}>
            <span aria-hidden className="mt-[3px] inline-flex w-3.5 h-3.5 rounded-full items-center justify-center flex-shrink-0" style={{ background: teal }}>
              <Check className="w-2 h-2 text-white" strokeWidth={3.5} />
            </span>
            <span>{l}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
